import { render, staticRenderFns } from "./BmglTk.vue?vue&type=template&id=414d514e&scoped=true&"
import script from "./BmglTk.vue?vue&type=script&lang=js&"
export * from "./BmglTk.vue?vue&type=script&lang=js&"
import style0 from "./BmglTk.vue?vue&type=style&index=0&id=414d514e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d514e",
  null
  
)

export default component.exports